export const BASE_SERIALIZE_OPTIONS = {
  encode: false,
  skipNulls: true,
  allowDots: false,
  indices: false,
  arrayFormat: 'brackets',
};
